import { useSyncExternalStore } from 'react';
import { THEME_STORAGE_KEY, applyTheme, readStoredTheme, type ThemeMode } from '@eombor/ui';

/** Tugmada ko'rinadigan nom. */
export const themeLabel: Record<ThemeMode, string> = {
  light: "Yorug'",
  dark: "Qorong'i",
  system: 'Tizim',
};

/** Bosilganda keyingi holat: yorug' → qorong'i → tizim. */
export const nextThemeMode: Record<ThemeMode, ThemeMode> = {
  light: 'dark',
  dark: 'system',
  system: 'light',
};

/**
 * Saqlangan tanlovni o'qish. `localStorage` taqiqlangan bo'lsa (maxfiy
 * oyna, korporativ siyosat) jim `system` ga qaytamiz — tema tanlash
 * ilovani to'xtatadigan narsa emas.
 */
const readMode = (): ThemeMode => {
  try {
    return readStoredTheme(localStorage);
  } catch {
    return 'system';
  }
};

/**
 * TEMA — MODUL DARAJASIDA, React holatida emas.
 *
 * Ilgari bu oddiy `useState` edi va har bir chaqiruvchi O'Z nusxasini
 * olardi. Ikki joy (`AppShell` va `ThemeToggle`) uni bir vaqtda o'qiganda
 * bu sezilmasdi: ikkalasi ham bir xil kalitga yozardi va sahifa
 * ko'rinishi `data-theme` dan kelardi. Sozlamalar «Menyu» sheet ichiga
 * ko'chgach esa yorilib chiqadi — sheet ichida temani almashtirgan odam
 * header'dagi belgi eski holatda turganini ko'rardi.
 *
 * Til ham xuddi shunday saqlanadi (`shared/i18n/index.ts`) — ikkalasi
 * bir xil naqsh: modul darajasidagi qiymat, obunachilar va
 * `useSyncExternalStore`.
 */
let currentMode: ThemeMode = readMode();

const listeners = new Set<() => void>();

export const getThemeMode = (): ThemeMode => currentMode;

export const setThemeMode = (mode: ThemeMode): void => {
  if (mode === currentMode) return;
  currentMode = mode;
  applyTheme(mode);
  try {
    localStorage.setItem(THEME_STORAGE_KEY, mode);
  } catch {
    // Saqlanmadi — tanlov faqat shu sessiyada yashaydi, ilova ishlayveradi.
  }
  for (const listener of listeners) listener();
};

const subscribe = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/**
 * Tema holati va uni almashtirish.
 *
 * `index.html` dagi to'suvchi skript ham xuddi shu kalitni o'qiydi,
 * shuning uchun birinchi chizilishda tema sakramaydi.
 */
export const useThemeMode = (): [ThemeMode, (mode: ThemeMode) => void] => [
  useSyncExternalStore(subscribe, getThemeMode, getThemeMode),
  setThemeMode,
];
